import { IconName, IconPrefix } from '@fortawesome/fontawesome-common-types';
import { HookActionTypeEnum } from 'generated/api/models/HookAction';

export interface EmailActionConfig {
  to: string;
  subject: string;
  body?: string;
  template?: string;
  attached_document_parameters?: string[];
  generated_attachments?: string[];
}

// SMS Action specific interfaces
export interface SmsActionConfig {
  to: string;
  message: string;
}

// Push Notification specific interfaces
export interface PushActionConfig {
  userId: string;
  userRole: 'patient' | 'physician' | 'admin';
  title: string;
  message: string;
  type?: string;
}

// Teams Message specific interfaces
export interface TeamsActionConfig {
  message: string;
  channel?: string;
}

export const HookActionTypes = [
  {
    value: HookActionTypeEnum.Email,
    label: 'Email',
    icon: 'envelope' as IconName,
    description: 'Send an email notification',
  },
  {
    value: HookActionTypeEnum.Sms,
    label: 'SMS',
    icon: 'message-sms' as IconName,
    description: 'Send an SMS text message',
  },
  {
    value: HookActionTypeEnum.Push,
    label: 'Push Notification',
    icon: 'bell' as IconName,
    description: 'Send a push notification to mobile devices',
  },
  {
    value: HookActionTypeEnum.Teams,
    label: 'Teams Message',
    icon: ['fab', 'microsoft'] as [IconPrefix, IconName],
    description: 'Send a message to Microsoft Teams',
  },
];
